// extracted by mini-css-extract-plugin
export var currencyInput = "_lk-1";
export var currencySymbol = "_lk-0";